import Vue from 'vue'
import VueRouter from 'vue-router'

import Base from '../views/Base.vue'
import SerialNumber from '../views/SerialNumber.vue'
import CustomerId from '../views/CustomerId.vue'
import DeviceType from '../views/DeviceType.vue'
import Board from '../views/Board.vue'
import Command from '../views/Command.vue'
import Group from '../views/Group.vue'
import Diameter from '../views/Diameter.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {
      path: '/',
      name: 'Base',
      component: Base
    },
    {
      path: '/serial-number',
      name: 'Serial Number',
      component: SerialNumber
    },
    {
      path: '/customer-id',
      name: 'Customer ID',
      component: CustomerId
    },
    {
      path: '/device-type',
      name: 'Device Type',
      component: DeviceType
    },
    {
      path: '/board',
      name: 'Board',
      component: Board
    },
    {
      path: '/command',
      name: 'Commmand',
      component: Command
    },
    {
      path: '/group',
      name: 'Group',
      component: Group
    },
    {
      path: '/diameter',
      name: 'Diameter',
      component: Diameter
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated && router.app.$keycloak.hasRealmRole('admin')) {
      next()
    } else {
      if (router.app.$keycloak.authenticated)
        router.app.$keycloak.logoutFn()
      else {
        const loginUrl = router.app.$keycloak.createLoginUrl()
        window.location.replace(loginUrl)
      }
    }
  } else {
    next()
  }
})

export default router
